import * as React from 'react';
/**
 * !ВАЖНО
 * DeprecatedBetInput - это временное решение до обновления на ui-kit 7
 * так как в 6 версии инпут не меняет значение при изменении из вне, если в него установлен фокус
 * в onChange нет event и нет возможность установить ref, поэтом убрать фокус нет возможности
 *
 * TODO после обновления ui-kit удалить DeprecatedBetInput и утилиту parseBet, вернуть компонент BetInput
 */
import { DeprecatedBetInput as BetInput } from './DeprecatedBetInput';
import { useAuctionState } from './hooks/useAuctionState';

export const BetInputContainer = () => {
  const { currentBet, hasNextBet, hasPreviousBet, loading, updateBet, decreaseBet, increaseBet } = useAuctionState();

  return (
    <BetInput
      disabled={loading}
      value={currentBet}
      loading={loading}
      previousDisabled={!hasPreviousBet}
      nextDisabled={!hasNextBet}
      onChange={updateBet}
      onPreviousClick={decreaseBet}
      onNextClick={increaseBet}
    />
  );
};
